import store from '../store'

const channel = new BroadcastChannel('user-presence-channel')

export function postStatusToChannel(userId, status) {
    channel.postMessage({
        user_id: userId,
        status: status,
        timestamp: Date.now()
    })
}

/* Listen messages from currently active tab */
export function handleUpdatedUserStatus(user_id, idleInstance) {
    channel.onmessage = (event) => {
        if (event.data.user_id === user_id) {
            const status = event.data.status

            /* Stop idle */
            idleInstance.stop()

            store.dispatch('activity/setCurrentActivity', [status, null, false])
        }
    }

    /* Start idle tracking when this tab gain focus */
    window.onfocus = () => {
        idleInstance.start()
    }
}